import type { AppState } from '@/types';

import { Status } from '../../constants';

export const networkStatusSelector = (state: AppState) => state.network.status;
export const isOnlineSelector = (state: AppState) => state.network.status === Status.ONLINE;
export const isOfflineSelector = (state: AppState) => state.network.status === Status.OFFLINE;
